export const MOTION_TOKENS = {
  duration: {
    instant: 0,
    feedback: 0.12,
    enter: 0.22,
    exit: 0.16,
    progress: 0.9,
  },
  ease: {
    standard: [0.2, 0.8, 0.2, 1],
    enter: [0.16, 1, 0.3, 1],
    exit: [0.4, 0, 1, 1],
  },
  performance: {
    animatedProperties: ['opacity', 'transform', 'stroke-dashoffset'],
    maxEnterMs: 280,
    maxExitMs: 200,
    maxStaggerMs: 40,
  },
} as const;

export type MotionPurpose = 'page' | 'panel' | 'drawer' | 'dialog' | 'list' | 'value';
